import "@hotwired/turbo"
import { type TurboFrameMissingEvent, type TurboSession } from "hotwired__turbo"

import airbrakeClient from "@/helpers/airbrake"

declare global {
  interface Window {
    Turbo: typeof Turbo
  }
}

// Hack around session apparently not having drive member
interface TurboSessionWithDrive extends TurboSession {
  drive: boolean
}

// Disable Turbo drive by default
;(Turbo.session as TurboSessionWithDrive).drive = false

// Hide frames with missing content by default
document.addEventListener("turbo:frame-missing", (e: TurboFrameMissingEvent) => {
  const target = e.target as HTMLElement
  target.hidden = true
})

// Disable Turbo prefetch across the entire app, including layouts that Turbo uses
document.addEventListener("turbo:before-prefetch", (e) => {
  e.preventDefault()
})

const renderTurboStream = async (url: string, options?: RequestInit): Promise<void> => {
  try {
    const response = await window.fetch(url, {
      ...options,
      headers: { Accept: "text/vnd.turbo-stream.html" }
    })

    if (response.ok) {
      const html = await response.text()
      window.Turbo.session.renderStreamMessage(html)
    } else {
      throw new Error("Stream fetch failure", { cause: response })
    }
  } catch (error) {
    if ((error as DOMException).name !== "AbortError") {
      void airbrakeClient.notify({
        error: `Couldn't load turbo stream for url: ${url}`,
        params: { error }
      })
    }
  }
}

export { renderTurboStream }
